import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import "./ServiceSelectionModal.css";
import { useEffect, useState } from "react";
import api from "../../services/api";

export default function ServiceSelectionModal({
  open,
  title,
  description,
  agreeText = "Agree",
  disagreeText = "Disagree",
  onClose,
  onAgree,
  setSelectedServiceId,
  selectedServiceId,
  branchId, 
}) {
  const [servicesDetails, setServicesDetails] = useState([]);

  const handleDisagree = () => {
    onClose?.();
  };

  const handleAgree = () => {
    onAgree?.();
    onClose?.();
  };

  useEffect(() => {
    getServices();
  }, []);

  const getServices = async () => {
    let servicesData = await api.get(`app/management/therapy-service/?branch_id=${branchId}`);
    setServicesDetails(servicesData?.data);
  };
  const handleChange = (event) => {
    setSelectedServiceId(event.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle className="slot_dialog_title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="slot_dialogtext"
        >
          {description}
        </DialogContentText>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid size={6}>
            <FormControl fullWidth variant="standard">
              <InputLabel className="custom-selectfield-label">
                Service Name
              </InputLabel>
              <Select
                fullWidth
                value={selectedServiceId}
                name="service_id"
                label="Service Name"
                onChange={handleChange}
                className="custom-selectfield"
              >
                {servicesDetails?.map((step) => (
                  <MenuItem value={step.id}>{step?.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDisagree}>{disagreeText}</Button>
        <Button onClick={handleAgree} autoFocus>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
